import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { WithIcon } from "@circle-react-shared/CommunityLogo/WithIcon";
import { WithLogo } from "@circle-react-shared/CommunityLogo/WithLogo";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface CommunityInfoProps {
  onClick?: () => void;
}

export const CommunityInfo = ({ onClick }: CommunityInfoProps) => {
  const { currentCommunity } = usePunditUserContext();
  const {
    logo_url: lightLogoUrl,
    dark_logo_url: darkLogoUrl,
    icon_url: lightIconUrl,
    dark_icon_url: darkIconUrl,
    name: communityName,
  } = currentCommunity ?? {};
  const logoUrl = darkLogoUrl || lightLogoUrl;
  const iconUrl = darkIconUrl || lightIconUrl;

  return (
    <button
      type="button"
      className="flex items-center gap-2 overflow-hidden"
      onClick={onClick}
      disabled={!onClick}
    >
      {logoUrl ? (
        <WithLogo
          logoURL={logoUrl}
          name={communityName ?? ""}
          imageClassName="!max-h-6"
        />
      ) : (
        <>
          {iconUrl && (
            <WithIcon
              iconUrl={iconUrl}
              name={communityName ?? ""}
              imageClassName="!max-h-6"
              className="flex items-center"
            />
          )}
          <Typography.TitleSm color="text-[#F0F3F5]" weight="medium" truncate>
            {communityName}
          </Typography.TitleSm>
        </>
      )}
    </button>
  );
};
